import { render, staticRenderFns } from "./CarInsuranceInfoDialog.vue?vue&type=template&id=618fe209&scoped=true"
import script from "./CarInsuranceInfoDialog.vue?vue&type=script&lang=js"
export * from "./CarInsuranceInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618fe209",
  null
  
)

export default component.exports